var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"covoit-map-thumb"},[_c('div',{ref:"mapEl",staticClass:"covoit-map-thumb__map"})])
}
var staticRenderFns = []

export { render, staticRenderFns }